import React, { useContext, useEffect, useState } from "react";
import "./audit.css";
import MaterialTable from "material-table";
import { ThemeProvider, createTheme } from "@mui/material";
import {
  FaPlusSquare,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaTrash,
  FaEdit,
  FaFilter,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaMinus,
  FaSave,
  FaSearch,
  FaThList,
  FaRegEdit,
} from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { RiDeleteBin5Line } from "react-icons/ri";
import { createTableIcons, CustomYearPicker, getDepartmentLabel, getPeriodLabels, tableHeaderStyle } from "../../CommonCase/CommonFunctions"
import { customStyles } from "../../CommonCase/CommonFunctions"


import { GET, POST, PUT } from "../../Common/HttpMethods/HttpMethods";
import { Url } from "../../../constants/ApiUrlConstants";
import { BsSearch } from "react-icons/bs";
import { contextData } from "../../../context/ContextProvider";
import FailModal from "../../Common/Popups/FailModal";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import SuccessModal from "../../Common/Popups/SuccessModal";

export const handleAddNewLine = async (id, auditId, isValid, newLine, setLoading, year, period, getChecklistData, token, setOpenSuccessModal, setSuccessMessage, setNewLine, setSelectedRef, setIsValid, setSessionExpiredModal, setFailMessage) => {

  if (isValid === false && newLine != "") {
    try {
      setLoading(true);
      let body = {
        testingProcedure: `${newLine}`,
        testProcYear: year,
        testProcPeriod: period.value,
        auditActionMaster: {
          actionItemId: ""
        },
        auditCalendar: {
          auditId: auditId
        },

        controlRefMaster: {
          controlRefId: id,
        },
      };

      let AddNewLineResp = await POST(Url.addTestProcedure, token, body);

      if (AddNewLineResp.SUCCESS) {
        getChecklistData().then(() => {
          setOpenSuccessModal(true);
          setSuccessMessage("Test procedure added successfully.");
        });
        setNewLine("");
        setSelectedRef("");
        setIsValid(false);
        // setLoading(false)
      } else if (AddNewLineResp?.STATUS == 401) {
        setLoading(false);

        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }
      else if (AddNewLineResp?.STATUS == 400) {
        setLoading(false);
      }
      else if (AddNewLineResp?.STATUS == 403) {
        setLoading(false);
      }
      else if (AddNewLineResp?.STATUS == 404) {
        setLoading(false);
      }
      else if (AddNewLineResp?.STATUS == 500) {
        setLoading(false);
      }else{
        setLoading(false);
      }

    } catch (error) {
      setLoading(false);
      setIsValid(false)
    }
  }
  else {

  }
};

export function handleProcedureInputChange(e, setProcedureInp, setIsValidEdit) {
  const value = e.target.value;
  setProcedureInp(value);
  const hasLeadingWhitespace = /^[^\s]/.test(value);
  const isEmpty = value.trim() === '';
  setIsValidEdit(!hasLeadingWhitespace && !isEmpty);
}


export const handleDeleteProcedureClick = (
  auditTestProcId,
  setDeleteProcId,
  setOpenWarningModal,
  setFailMessage
) => {
  setDeleteProcId(auditTestProcId);
  setOpenWarningModal(true);
  setFailMessage("Are you sure you want to delete test procedure?");
};

export const handleAddProcedureClick = (
  rowData,
  setSelectedRef,
  setNewLine,
  setIsValid,
  setIsValidEdit
) => {
  const controlRefId = rowData?.controlRefId;

  // Set state for the selected reference
  setSelectedRef(controlRefId);

  // Reset input and validation states
  setNewLine("");
  setIsValid(false);
  setIsValidEdit(false);
};


export const birthYearChange = (date,setBirthYearForCalender,setYear) => {

  setBirthYearForCalender(date);
  setYear({
    label: date.getFullYear(),
    value: date.getFullYear()
  })
};


export const handleTextareaChange = (event, setNewLine, setIsValid) => {
  const value = event.target.value;
  setNewLine(value);

  // Check for leading whitespace
  const hasLeadingWhitespace = /^[^\s]/.test(value);
  
  // Update validity state
  setIsValid(!hasLeadingWhitespace);
};


export const handleEditLine = async (testId, lineId, isValidEdit, procedureInp, setLoading, token, getChecklistData, setOpenSuccessModal, setSuccessMessage, setProcedureInp, setIndexForEdit, setSessionExpiredModal, setFailMessage, setIsValidEdit) => {
  if (isValidEdit === false && procedureInp !== "") {
    try {
      setLoading(true);

      let body = {
        testingProcedure: `${procedureInp}`,
        procedureObservationId: lineId,
        auditTestProcId: testId,
      };

      // Mocking PUT request
      let AddNewLineResp = await PUT(Url.updateCheckList, token, body);

      if (AddNewLineResp.SUCCESS) {
        getChecklistData().then(() => {
          setOpenSuccessModal(true);
          setSuccessMessage("Test procedure updated successfully.");
        });
        setProcedureInp("");
        setIndexForEdit({
          index: "",
          refId: "",
        });
        setLoading(false);  // Ensure setLoading is called here
      } else if (AddNewLineResp?.STATUS === 401) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (AddNewLineResp?.STATUS === 400) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }
      else if (AddNewLineResp?.STATUS === 403) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (AddNewLineResp?.STATUS === 404) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (AddNewLineResp?.STATUS === 500) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else{
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }
    } catch (error) {
        setLoading(false);
        setIsValidEdit(false);
  
    }
  }else{
    setLoading(false);
    setFailMessage("Something is wrong.");
  }
};

export const handleDeleteLine = async (setOpenWarningModal, setLoading, deleteProcId, token, getChecklistData, setSessionExpiredModal, setFailMessage) => {
  try {
    setOpenWarningModal(false);
    // setLoading(true);

    fetch(Url.deleteTestProcedureById.replace("{id}", deleteProcId), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
        'X-CSRF-TOKEN': 'YmUyYjAzODItOGIyZi00Njk1LThhOGMtYjhkYzVmZDY0YjI2',
      },
    })
      .then((resp) => resp.json())
      .then((res) => {
        if (res.SUCCESS) {
          getChecklistData();
        } else if (res?.STATUS === 401) {
          // setLoading(false);
          setSessionExpiredModal(true);
          setFailMessage("Session expired");
        } else if (res?.STATUS === 400) {
          // setLoading(false);
          setSessionExpiredModal(true);
          setFailMessage("Session expired");
        } else if (res?.STATUS === 403) {
          // setLoading(false);
          setSessionExpiredModal(true);
          setFailMessage("Session expired");
        } else if (res?.STATUS === 404) {
          // setLoading(false);
          setSessionExpiredModal(true);
          setFailMessage("Session expired");
        } else if (res?.STATUS === 500) {
          // setLoading(false);
          setSessionExpiredModal(true);
          setFailMessage("Session expired");
        } else {
          // setLoading(false);
        }
      });
  } 
  catch (error) {
    // setLoading(false);
  }
};


export const handleSelectChange = (
  setDept,
  setSearchInput,
  setIsValidEdit,
  setIsValid,
  setSelectedRef,
  setNewLine
) => (selectedOption) => {
  setDept(selectedOption);
  setSearchInput("");
  setIsValidEdit(false);
  setIsValid(false);
  setSelectedRef("");
  setNewLine("");
};


export const adjustTextareaHeight = (element) => {
  let addStep = document.getElementById("addStep");
  if (addStep) {
    addStep.style.height = "auto";
    addStep.style.height = addStep.scrollHeight + "px";
  }
};

export const adjustEditTextareaHeight = () => {
  let editStep = document.getElementById("edittextarea");
  if (editStep) {
    editStep.style.height = "auto";
    editStep.style.height = editStep.scrollHeight + "px";
  }
};


export const handleNavigate = (navigate) => {
  navigate("/main/audit/calendar");
};

export const navigateAfterSubmit = (navigate) => {
  navigate("/main/audit/checklist");
};

export const handleCloseFailModel = (setOpenWarningModal) => {
  setOpenWarningModal(false);
};

export const handleSessionExpClose = (navigate, setActive) => {
  sessionStorage.clear();
  navigate("/login");
  setActive("tab1");
};


export const getCurrentYear = async (
  GET,
  Url,
  token,
  setLoading,
  setOpenMsgModal,
  setFailMessage,
  setYearList,
  getDepartmentLabel,
  getPeriodLabels,
  setYear,
  setPeriod,
  setDept,
  setSessionExpiredModal
) => {
  try {
    setLoading(true);

    const getYear = await GET(Url?.getAuditYear, token);

    if (getYear.SUCCESS) {
      if (getYear?.MESSAGE) {
        setLoading(false);
        setOpenMsgModal(true);
        setFailMessage(getYear?.MESSAGE);
      }

      let yearData = getYear?.DATA?.yearList?.map((i) => {
        return { label: i, value: i };
      });
      setYearList(yearData);

      let departmentLabel = getDepartmentLabel(getYear?.DATA?.latestDepartTag);
      let periodLabels = getPeriodLabels(getYear?.DATA?.latestQuarter);

      setYear({
        label: getYear?.DATA?.latestYear,
        value: getYear?.DATA?.latestYear,
      });
      setPeriod({
        label: periodLabels,
        value: getYear?.DATA?.latestQuarter,
      });
      setDept({
        label: departmentLabel,
        value: getYear?.DATA?.latestDepartTag,
      });
    } else if (getYear?.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getYear?.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getYear?.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getYear?.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getYear?.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }
  } catch (error) {
    setLoading(false);
  } finally {
    setLoading(false);
  }
};


const Audit = () => {
  const theme = createTheme();
  const navigate = useNavigate();

  let d = new Date()

  const tableIcons = createTableIcons()

  const { setLoading, setActive } = useContext(contextData);

  const [data, setData] = useState([]);
  const [dataCopy, setCopyData] = useState([]);
  const [selectedRef, setSelectedRef] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [newLine, setNewLine] = useState("");
  const [procedureInp, setProcedureInp] = useState();
  const [deleteProcId, setDeleteProcId] = useState();
  const [failMessage, setFailMessage] = useState("");
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [openMsgModal, setOpenMsgModal] = useState(false);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isValidEdit, setIsValidEdit] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  const [indexForEdit, setIndexForEdit] = useState({
    index: "",
    refId: "",
  });

  const [dept, setDept] = useState({
    label: "HR",
    value: 1,
  });
  const [period, setPeriod] = useState({ value: 'Quarter 1', label: 'Q1 (April - June)' },);

  const token = sessionStorage.getItem("TOKEN");


  const [year, setYear] = useState({
    label: `${d.getFullYear()}`,
    value: `${d.getFullYear()}`,
  });


  const [yearList, setYearList] = useState([])


  useEffect(() => {
    getCurrentYear(
      GET,
      Url,
      token,
      setLoading,
      setOpenMsgModal,
      setFailMessage,
      setYearList,
      getDepartmentLabel,
      getPeriodLabels,
      setYear,
      setPeriod,
      setDept,
      setSessionExpiredModal
    );
  }, []);


  let options = [
    {
      label: "HR",
      value: 1,
    },
    {
      label: "Governance",
      value: 2,
    },
    {
      label: "IT",
      value: 3,
    },
    {
      label: "Facillity",
      value: 4,
    },
  ];


  const periodOptions = [

    { value: 'Quarter 1', label: 'Q1 (April - June)' },
    { value: 'Quarter 2', label: 'Q2 (July - September)' },
    { value: 'Quarter 3', label: 'Q3 (October - December)' },
    { value: 'Quarter 4', label: 'Q4 (January - March)' },
  ];

  useEffect(() => {
    adjustTextareaHeight();
  }, [newLine]);

  useEffect(() => {
    adjustEditTextareaHeight();
  }, [procedureInp]);

  useEffect(() => {
    getChecklistData();
  }, [dept, year, period]);

  useEffect(() => {
    if (searchInput == "") {
      setData(dataCopy);
    } else {
      setData(
        dataCopy.filter((item) => `${item.controlRefNo}`.includes(searchInput))
      );
    }
  }, [searchInput]);

  const dataStyle = {
    // borderRight: '1px solid gray',
    fontWeight: "600",
    color: "black",
  };

  const columns = [
    {
      title: <p style={{ padding: "2px 0px" }}>CONTROL REFERENCE</p>,
      field: "controlReference",
      sorting: false,
      render: (rowData) => {
        return (
          <div
            style={{ ...dataStyle, position: "relative", textAlign: "right" }}
            className="audit-table-row-data ref-no-checklist"
          >
            <p style={{ paddingLeft: 5, paddingRight: 10 }}>{rowData?.controlRefNo}</p>
            {rowData?.controlRefShort && (
              <div className="cref-number-tooltip-checklist">
                {rowData?.controlRefShort}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: <p>CONTROL OBJECTIVE</p>,
      field: "controlObjective",
      sorting: false,
      render: (rowData) => {
        return (
          <div className="audit-table-row-data">
            {rowData?.controlObject ? rowData?.controlObject : "Not available"}
          </div>
        );
      },
    },
    {
      title: <p>CONTROL DESCRIPTION</p>,
      field: "controlDescription",
      sorting: false,
      render: (rowData) => {
        return (
          <div className="audit-table-row-data">
            {rowData?.controlDescription
              ? rowData?.controlDescription
              : "Not available"}
          </div>
        );
      },
    },
    {
      title: <p>RESPONSIBLE DEPARTMENT</p>,
      field: "department",
      sorting: false,
      render: (rowData) => {
        return (
          <div className="audit-table-row-data">
            {rowData?.deptartmentTagMaster?.deptTag}
          </div>
        );
      },
    },
    {
      title: <p>TESTING PROCEDURE</p>,
      field: "testingProcedure",
      sorting: false,
      render: (rowData) => {
        return (
          <div className="testing_proced_main">
            {rowData?.auditTestProcedureList?.map((i, index) => {
              return (
                <div>
                  {index == indexForEdit.index &&
                    rowData?.controlRefId == indexForEdit.refId ? (
                    <div>
                      <div className="test_procedure_row_onedit">
                        <textarea
                          id="edittextarea"
                          onChange={(e) => handleProcedureInputChange(e, setProcedureInp, setIsValidEdit)}
                          className="test_procedure_row_textarea"
                        >
                          {procedureInp}
                        </textarea>
                        <div className="testProcBTN">
                          {/* <button
                            onClick={() => {
                              setIndexForEdit({ index: "", refId: "" });
                              setProcedureInp('');
                              // setIsValidEdit(true)
                            }}
                            className="test_procedure_row_button"
                          >
                            <AiOutlineClose fill="#00ADEE" size={"15px"} />
                          </button> */}
                          <button
                            onClick={() =>
                              handleEditLine(
                                i?.auditTestProcId,
                                i?.procedureObservationId,
                                isValidEdit, procedureInp, setLoading, token, getChecklistData, setOpenSuccessModal, setSuccessMessage, setProcedureInp, setIndexForEdit, setSessionExpiredModal, setFailMessage, setIsValidEdit
                              )
                            }
                            className="test_procedure_row_button"
                          >
                            <FaCheck fill="#00ADEE" size={"15px"} />
                          </button>
                        </div>
                      </div>
                      {isValidEdit && <div style={{ color: 'red', marginLeft: 5 }}>Input cannot have leading whitespace or be empty.</div>}
                    </div>
                  ) : (
                    <div className="test_proc_row">
                      <div className="test_procedure-text">
                        <div className="edit-icon">
                          <span onClick={() => {
                            setIndexForEdit({
                              index: index,
                              refId: rowData?.controlRefId,
                            });
                            setProcedureInp(i.testingProcedure);
                          }}>
                            <FaRegEdit fill="#00ADEE" size={"10px"} />
                          </span>
                        </div>
                        <div className="test_proc_index">{index + 1}.</div>
                        <div className="test_proc_text">
                          {i?.testingProcedure}
                        </div>
                      </div>
                      {/* <button
                        className="test_proc_row_button"
                        onClick={() => {
                          setIndexForEdit({
                            index: index,
                            refId: rowData?.controlRefId,
                          });
                          setProcedureInp(i.testingProcedure);
                        }}
                      >
                        <SlPencil fill="#00ADEE" size={"14px"} />
                      </button> */}
                      <button
                        className="test_proc_row_button"
                        // onClick={() => {

                        //   setDeleteProcId(i?.auditTestProcId);
                        //   setOpenWarningModal(true);
                        //   setFailMessage(
                        //     "Are you sure you want to delete test procedure?"
                        //   );
                        // }}
                        onClick={() =>handleDeleteProcedureClick(i?.auditTestProcId,setDeleteProcId,setOpenWarningModal,setFailMessage)
                        }
                      >
                        <RiDeleteBin5Line fill="#00ADEE" size={"15px"} />
                      </button>
                    </div>
                  )}
                </div>
              );
            })
            }
            {selectedRef == rowData?.controlRefId ? (
              <div>

                <div className="add_new_test_proc_div">
                  <div className="edit-icon-cross" onClick={() => {
                    setSelectedRef("");
                    setNewLine("");
                    // setIsValid(true)
                  }}>
                    <AiOutlineClose fill="#00ADEE" size={"10px"} />
                  </div>
                  <textarea
                    style={{ paddingTop: "5px" }}
                    className="add_new_test_proc_textarea"
                    type="text"
                    placeholder="Add Testing Procedure"
                    // onChange={(e) => {
                    //   setIsValid(false);
                    //   let value = e.target.value;
                    //   setNewLine(value);
                    //   const hasLeadingWhitespace = /^[^\s]/.test(value);
                    //   setIsValid(!hasLeadingWhitespace);
                    // }}
                    onChange={(e) => handleTextareaChange(e, setNewLine, setIsValid)}
                    id="addStep"
                  >
                    {newLine}
                  </textarea>
                  <button
                    onClick={() => {

                      handleAddNewLine(rowData?.controlRefId, rowData?.auditCalendar?.auditId, isValid, newLine, setLoading, year, period, getChecklistData, token, setOpenSuccessModal, setSuccessMessage, setNewLine, setSelectedRef, setIsValid, setSessionExpiredModal, setFailMessage);
                    }}
                    className="test_procedure_row_button"
                  >
                    <FaCheck fill="#00ADEE" size={"15px"} />
                  </button>
                </div>

                {isValid && <div style={{ color: 'red', paddingLeft: 5 }}>Input cannot have leading whitespace or be empty.</div>}

              </div>

            ) : (
              <button
                className="add_proc_button"
                // onClick={() => {
                //   setSelectedRef(rowData?.controlRefId);
                //   setNewLine("");
                //   setIsValid(false);
                //   setIsValidEdit(false)
                // }}
                onClick={() =>
                  handleAddProcedureClick(rowData,setSelectedRef,setNewLine,setIsValid,setIsValidEdit)
                }
              >
                + &nbsp; Add
              </button>
            )
            }
          </div >
        );
      },
    },
  ];



  const getChecklistData = async () => {
    try {
      setLoading(true);
      let checkListResp = await GET(
        Url.getAllCheckList.replace("{deptId}", dept?.value).replace("{year}", year?.value).replace("{quarter}", period?.value).replace("{type}", 0),
        token
      );
      if (checkListResp.SUCCESS) {
        if (checkListResp?.MESSAGE) {
          setLoading(false)
          setOpenMsgModal(true)
          setFailMessage(checkListResp?.MESSAGE)
        }

        setData(checkListResp?.DATA);
        setCopyData(checkListResp?.DATA);
        setLoading(false);

      } else if (checkListResp?.STATUS == 401) {
        setLoading(false);

        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }
    } catch (error) {
      setLoading(false);

    } finally {
      setLoading(false);
    }
  };

  const [birthYearForCalender, setBirthYearForCalender] = useState(new Date());

   return (
    <div className="audit-main-div">
      <div className="audit-uitility-container">
        <div className="dept-selector">
          <span >Year &nbsp; </span>
          <CustomYearPicker
            selectedDate={birthYearForCalender}
            // onDateChange={()=>birthYearChange(date,setBirthYearForCalender,setYear)}
            onDateChange={(date) => {
              const parsedDate = new Date(date);
              birthYearChange(parsedDate, setBirthYearForCalender, setYear);
            }}
          />

          <span style={{ marginLeft: 15 }}>Department &nbsp; </span>
          <Select
            isSearchable={false}
            options={options}
            styles={customStyles}
            value={dept}
            onChange={handleSelectChange(
              setDept,
              setSearchInput,
              setIsValidEdit,
              setIsValid,
              setSelectedRef,
              setNewLine
            )}
          />

          <span style={{ marginLeft: 15 }}>Period &nbsp; </span>
          <Select
            isSearchable={false}
            options={periodOptions}
            styles={{
              ...customStyles,
              control: (provided, state) => ({
                ...customStyles.control(provided, state),
                height: 25,
                width: 195,
              }),
            }}
            value={period}
            onChange={(e) => {
              setPeriod(e);
            }}
          />
        </div>
        <div className="Audit-searchbar-cont">
          <div className="serchbox">
            <BsSearch fill="#999999" />
            <input
              type="text"
              placeholder="Search by Control Reference ID"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="audit-table-container">
        <ThemeProvider theme={theme}>
          <MaterialTable
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <span className="no_data_found_table">No Audit Scheduled - <span onClick={() => handleNavigate(navigate)} className="createAuditFunc">Create New Audit</span></span>
                ),
              },
            }}
            data={data}
            style={{ overflowX: "auto" }}
            columns={columns}
            icons={tableIcons}
            options={{
              toolbar: false,
              search: false,
              draggable: false,
              pageSizeOptions: [5, 10, 15, 20],
              pageSize: 10,
              zIndex: 0,
              headerStyle: {
                position: "sticky",
                top: -1,
                ...tableHeaderStyle,
              },
              maxBodyHeight: "66vh",
              minBodyHeight: "66vh",
            }}
          />
        </ThemeProvider>
      </div>
      {/* DELETE MODAL.............. */}
      <FailModal
        openFailModal={openWarningModal}
        setOpenFailModal={setOpenWarningModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleDeleteLine(setOpenWarningModal, setLoading, deleteProcId, token, getChecklistData, setSessionExpiredModal, setFailMessage)}
        recallFunctiononClose={() => handleCloseFailModel(setOpenWarningModal)}
      />
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(navigate, setActive)}
        recallFunctiononClose={() => handleSessionExpClose(navigate, setActive)}
      />

      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={() => navigateAfterSubmit(navigate)}
        recallFunctionOnClose={() => navigateAfterSubmit(navigate)}
      />
    </div>
  );
};

export default Audit;
